// Item definitions database
export const ITEMS = {
    // Consumables
    health_potion: {
        id: 'health_potion',
        name: 'Health Potion',
        description: 'Restores 50 health.',
        type: 'consumable',
        rarity: 'common',
        icon: '🧪',
        stackable: true,
        maxStack: 20,
        sellPrice: 5,
        stats: { health: 50 },
    },
    mana_potion: {
        id: 'mana_potion',
        name: 'Mana Potion',
        description: 'Restores 50 mana.',
        type: 'consumable',
        rarity: 'common',
        icon: '💧',
        stackable: true,
        maxStack: 20,
        sellPrice: 5,
        stats: { mana: 50 },
    },
    // Materials
    slime_goo: {
        id: 'slime_goo',
        name: 'Slime Goo',
        description: 'Gooey substance dropped by slimes. Used for crafting.',
        type: 'material',
        rarity: 'common',
        icon: '🟢',
        stackable: true,
        maxStack: 99,
        sellPrice: 2,
    },
    slime_core: {
        id: 'slime_core',
        name: 'Slime Core',
        description: 'A rare crystallized core from a slime.',
        type: 'material',
        rarity: 'uncommon',
        icon: '💎',
        stackable: true,
        maxStack: 99,
        sellPrice: 15,
    },
    // Weapons
    rusty_sword: {
        id: 'rusty_sword',
        name: 'Rusty Sword',
        description: 'A worn blade. Better than nothing.',
        type: 'weapon',
        rarity: 'common',
        icon: '⚔️',
        stackable: false,
        maxStack: 1,
        sellPrice: 10,
        stats: { damage: 5 },
        equipSlot: 'mainHand',
        levelRequirement: 1,
    },
    iron_sword: {
        id: 'iron_sword',
        name: 'Iron Sword',
        description: 'A sturdy iron blade.',
        type: 'weapon',
        rarity: 'uncommon',
        icon: '🗡️',
        stackable: false,
        maxStack: 1,
        sellPrice: 50,
        stats: { damage: 12 },
        equipSlot: 'mainHand',
        levelRequirement: 3,
    },
    // Armor
    leather_vest: {
        id: 'leather_vest',
        name: 'Leather Vest',
        description: 'Basic leather protection.',
        type: 'armor',
        rarity: 'common',
        icon: '🦺',
        stackable: false,
        maxStack: 1,
        sellPrice: 15,
        stats: { armor: 5 },
        equipSlot: 'chest',
        levelRequirement: 1,
    },
    // Quest items
    slime_sample: {
        id: 'slime_sample',
        name: 'Slime Sample',
        description: 'A sample of slime for research purposes.',
        type: 'quest',
        rarity: 'common',
        icon: '📦',
        stackable: true,
        maxStack: 10,
        sellPrice: 0,
    },
    // More consumables
    greater_health_potion: {
        id: 'greater_health_potion',
        name: 'Greater Health Potion',
        description: 'Restores 150 health.',
        type: 'consumable',
        rarity: 'uncommon',
        icon: '🧪',
        stackable: true,
        maxStack: 20,
        sellPrice: 25,
        stats: { health: 150 },
    },
    // More materials
    spider_silk: {
        id: 'spider_silk',
        name: 'Spider Silk',
        description: 'Strong silk from forest spiders. Used for crafting.',
        type: 'material',
        rarity: 'common',
        icon: '🕸️',
        stackable: true,
        maxStack: 99,
        sellPrice: 3,
    },
    spider_fang: {
        id: 'spider_fang',
        name: 'Spider Fang',
        description: 'A venomous fang from a spider.',
        type: 'material',
        rarity: 'uncommon',
        icon: '🦷',
        stackable: true,
        maxStack: 99,
        sellPrice: 8,
    },
    wolf_pelt: {
        id: 'wolf_pelt',
        name: 'Wolf Pelt',
        description: 'A thick fur pelt from a forest wolf.',
        type: 'material',
        rarity: 'common',
        icon: '🐺',
        stackable: true,
        maxStack: 99,
        sellPrice: 5,
    },
    wolf_fang: {
        id: 'wolf_fang',
        name: 'Wolf Fang',
        description: 'Sharp fangs from a wolf.',
        type: 'material',
        rarity: 'uncommon',
        icon: '🦷',
        stackable: true,
        maxStack: 99,
        sellPrice: 10,
    },
    raw_meat: {
        id: 'raw_meat',
        name: 'Raw Meat',
        description: 'Uncooked meat. Can be cooked for food.',
        type: 'material',
        rarity: 'common',
        icon: '🥩',
        stackable: true,
        maxStack: 99,
        sellPrice: 2,
    },
    bone_fragment: {
        id: 'bone_fragment',
        name: 'Bone Fragment',
        description: 'A piece of ancient bone.',
        type: 'material',
        rarity: 'common',
        icon: '🦴',
        stackable: true,
        maxStack: 99,
        sellPrice: 3,
    },
    tattered_cloth: {
        id: 'tattered_cloth',
        name: 'Tattered Cloth',
        description: 'Old worn cloth from goblin clothing.',
        type: 'material',
        rarity: 'common',
        icon: '🧵',
        stackable: true,
        maxStack: 99,
        sellPrice: 2,
    },
    leather_scraps: {
        id: 'leather_scraps',
        name: 'Leather Scraps',
        description: 'Pieces of rough leather.',
        type: 'material',
        rarity: 'common',
        icon: '🥋',
        stackable: true,
        maxStack: 99,
        sellPrice: 3,
    },
    orc_tusk: {
        id: 'orc_tusk',
        name: 'Orc Tusk',
        description: 'A large tusk from an orc.',
        type: 'material',
        rarity: 'uncommon',
        icon: '🦷',
        stackable: true,
        maxStack: 99,
        sellPrice: 15,
    },
    goblin_ear: {
        id: 'goblin_ear',
        name: 'Goblin Ear',
        description: 'A pointed ear from a goblin.',
        type: 'material',
        rarity: 'common',
        icon: '👂',
        stackable: true,
        maxStack: 99,
        sellPrice: 4,
    },
    spider_venom: {
        id: 'spider_venom',
        name: 'Spider Venom',
        description: 'Toxic venom extracted from a spider.',
        type: 'material',
        rarity: 'uncommon',
        icon: '☠️',
        stackable: true,
        maxStack: 99,
        sellPrice: 12,
    },
    leather_armor: {
        id: 'leather_armor',
        name: 'Leather Armor',
        description: 'Sturdy leather chest armor.',
        type: 'armor',
        rarity: 'uncommon',
        icon: '🥋',
        stackable: false,
        maxStack: 1,
        sellPrice: 35,
        stats: { armor: 12, stamina: 3 },
        equipSlot: 'chest',
        levelRequirement: 3,
    },
    steel_sword: {
        id: 'steel_sword',
        name: 'Steel Sword',
        description: 'A finely crafted steel blade.',
        type: 'weapon',
        rarity: 'rare',
        icon: '⚔️',
        stackable: false,
        maxStack: 1,
        sellPrice: 120,
        stats: { damage: 22, critChance: 2 },
        equipSlot: 'mainHand',
        levelRequirement: 5,
    },
    // Currency items
    copper_coin: {
        id: 'copper_coin',
        name: 'Copper Coin',
        description: 'A small copper coin.',
        type: 'material',
        rarity: 'common',
        icon: '🪙',
        stackable: true,
        maxStack: 99,
        sellPrice: 1,
    },
    gold_coin: {
        id: 'gold_coin',
        name: 'Gold Coin',
        description: 'A valuable gold coin.',
        type: 'material',
        rarity: 'uncommon',
        icon: '💰',
        stackable: true,
        maxStack: 99,
        sellPrice: 10,
    },
    // More weapons
    rusty_dagger: {
        id: 'rusty_dagger',
        name: 'Rusty Dagger',
        description: 'A small rusty dagger.',
        type: 'weapon',
        rarity: 'common',
        icon: '🗡️',
        stackable: false,
        maxStack: 1,
        sellPrice: 8,
        stats: { damage: 4 },
        equipSlot: 'mainHand',
        levelRequirement: 1,
    },
    crude_axe: {
        id: 'crude_axe',
        name: 'Crude Axe',
        description: 'A roughly made axe.',
        type: 'weapon',
        rarity: 'common',
        icon: '🪓',
        stackable: false,
        maxStack: 1,
        sellPrice: 12,
        stats: { damage: 7 },
        equipSlot: 'mainHand',
        levelRequirement: 2,
    },
    apprentice_staff: {
        id: 'apprentice_staff',
        name: 'Apprentice Staff',
        description: 'A basic magical staff for aspiring mages.',
        type: 'weapon',
        rarity: 'common',
        icon: '🪄',
        stackable: false,
        maxStack: 1,
        sellPrice: 15,
        stats: { spellPower: 5 },
        equipSlot: 'mainHand',
        levelRequirement: 1,
    },
    wooden_staff: {
        id: 'wooden_staff',
        name: 'Wooden Staff',
        description: 'A simple wooden staff.',
        type: 'weapon',
        rarity: 'common',
        icon: '🪵',
        stackable: false,
        maxStack: 1,
        sellPrice: 10,
        stats: { spellPower: 3 },
        equipSlot: 'mainHand',
        levelRequirement: 1,
    },
    worn_dagger: {
        id: 'worn_dagger',
        name: 'Worn Dagger',
        description: 'A well-used dagger.',
        type: 'weapon',
        rarity: 'common',
        icon: '🔪',
        stackable: false,
        maxStack: 1,
        sellPrice: 6,
        stats: { damage: 3 },
        equipSlot: 'mainHand',
        levelRequirement: 1,
    },
    // More armor
    cloth_robe: {
        id: 'cloth_robe',
        name: 'Cloth Robe',
        description: 'A simple cloth robe.',
        type: 'armor',
        rarity: 'common',
        icon: '👘',
        stackable: false,
        maxStack: 1,
        sellPrice: 10,
        stats: { armor: 2, mana: 10 },
        equipSlot: 'chest',
        levelRequirement: 1,
    },
    novice_robe: {
        id: 'novice_robe',
        name: 'Novice Robe',
        description: 'A robe for novice spellcasters.',
        type: 'armor',
        rarity: 'common',
        icon: '👗',
        stackable: false,
        maxStack: 1,
        sellPrice: 12,
        stats: { armor: 2, spirit: 2 },
        equipSlot: 'chest',
        levelRequirement: 1,
    },
    leather_jerkin: {
        id: 'leather_jerkin',
        name: 'Leather Jerkin',
        description: 'Light leather armor.',
        type: 'armor',
        rarity: 'common',
        icon: '🎽',
        stackable: false,
        maxStack: 1,
        sellPrice: 12,
        stats: { armor: 4, agility: 1 },
        equipSlot: 'chest',
        levelRequirement: 1,
    },
    // Elite/Rare drops
    chieftain_staff: {
        id: 'chieftain_staff',
        name: 'Chieftain Staff',
        description: 'A staff wielded by the goblin chieftain.',
        type: 'weapon',
        rarity: 'rare',
        icon: '🔱',
        stackable: false,
        maxStack: 1,
        sellPrice: 75,
        stats: { damage: 15, spellPower: 8 },
        equipSlot: 'mainHand',
        levelRequirement: 4,
    },
    slime_ring: {
        id: 'slime_ring',
        name: 'Ring of Ooze',
        description: 'A ring formed from crystallized slime.',
        type: 'armor',
        rarity: 'rare',
        icon: '💍',
        stackable: false,
        maxStack: 1,
        sellPrice: 100,
        stats: { health: 20, armor: 5 },
        equipSlot: 'ring',
        levelRequirement: 3,
    },
    // Boss drops
    crown_of_the_slime_king: {
        id: 'crown_of_the_slime_king',
        name: 'Crown of the Slime King',
        description: 'A legendary crown worn by the Slime King himself.',
        type: 'armor',
        rarity: 'legendary',
        icon: '👑',
        stackable: false,
        maxStack: 1,
        sellPrice: 500,
        stats: { health: 50, armor: 15, stamina: 10 },
        equipSlot: 'head',
        levelRequirement: 8,
    },
    slime_pet: {
        id: 'slime_pet',
        name: 'Mini Slime Pet',
        description: 'A tiny slime that follows you around!',
        type: 'misc',
        rarity: 'epic',
        icon: '🐛',
        stackable: false,
        maxStack: 1,
        sellPrice: 0, // Unsellable
    },
};
// Rarity colors for UI
export const RARITY_COLORS = {
    common: '#9d9d9d',
    uncommon: '#1eff00',
    rare: '#0070dd',
    epic: '#a335ee',
    legendary: '#ff8000',
};
//# sourceMappingURL=items.js.map